module.exports = __webpack_public_path__ + "img/cetak_resi.b941a3b4.svg";